module.exports = __webpack_public_path__ + "static/media/tree-palm.06c08078.svg";